import React from 'react';

import Box from '@mui/material/Box';
import { useColorScheme } from '@mui/material/styles';

import MDEditor from '@uiw/react-md-editor';

type Props = {
  /** マークダウンソース */
  source: string;
};

/**
 * マークダウン本文ビューワー。
 * 新規依存を追加せず、導入済みの @uiw/react-md-editor が持つ Markdown プレビュー
 * （= @uiw/react-markdown-preview）を利用して描画する。
 */
const MarkdownViewer: React.FC<Props> = ({ source }) => {
  const { mode, systemMode } = useColorScheme();
  const resolved = mode === 'system' ? systemMode : mode;
  const isDark = resolved === 'dark';

  return (
    <Box
      data-color-mode={isDark ? 'dark' : 'light'}
      sx={{
        maxWidth: 900,
        mr: 'auto',
        '& .wmde-markdown': { backgroundColor: 'transparent', fontSize: '0.95rem' },
      }}
    >
      <MDEditor.Markdown source={source} />
    </Box>
  );
};

export default MarkdownViewer;
